import { render, staticRenderFns } from "./ResConfirm.vue?vue&type=template&id=5a3e2c25&scoped=true&lang=pug"
import script from "./ResConfirm.vue?vue&type=script&lang=js"
export * from "./ResConfirm.vue?vue&type=script&lang=js"
import style0 from "./ResConfirm.vue?vue&type=style&index=0&id=5a3e2c25&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e2c25",
  null
  
)

export default component.exports